export enum UserInviteStatus {
  /** The User has been invited but hasn't accepted the invitation yet */
  Pending = 'pending',
  /** The User has accepted the invite */
  Accepted = 'accepted',
}
